import { render, staticRenderFns } from "./KidsLifecycleDialog.vue?vue&type=template&id=ec3cdf8a&scoped=true"
import script from "./KidsLifecycleDialog.vue?vue&type=script&lang=js"
export * from "./KidsLifecycleDialog.vue?vue&type=script&lang=js"
import style0 from "./KidsLifecycleDialog.vue?vue&type=style&index=0&id=ec3cdf8a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3cdf8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec3cdf8a')) {
      api.createRecord('ec3cdf8a', component.options)
    } else {
      api.reload('ec3cdf8a', component.options)
    }
    module.hot.accept("./KidsLifecycleDialog.vue?vue&type=template&id=ec3cdf8a&scoped=true", function () {
      api.rerender('ec3cdf8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/StudentDialog/KidsLifecycleDialog.vue"
export default component.exports